import { Link } from 'react-router-dom'
import { RotateCcw } from 'lucide-react'
import { StatusView } from '@loop3/ui'

interface ErrorPageProps {
  /** Optional message to show below the description (e.g. error.message in dev). */
  detail?: string
  /** Callback to retry the action that failed. */
  onReset?: () => void
}

export function ErrorPage({ detail, onReset }: ErrorPageProps) {
  return (
    <StatusView
      code="500"
      title="Something went wrong"
      description="An unexpected error occurred. Try again, or head back home."
      action={
        onReset ? (
          <button
            type="button"
            onClick={onReset}
            className="group inline-flex items-center gap-2 rounded-md border border-border px-4 py-2.5 text-sm font-medium hover:border-[var(--l3-violet)] hover:bg-[var(--l3-violet-soft)] hover:text-[var(--l3-violet)] transition-colors"
          >
            <RotateCcw className="size-4 transition-transform group-hover:-rotate-45" />
            Try again
          </button>
        ) : (
          <Link
            to="/"
            className="group inline-flex items-center gap-2 rounded-md border border-border px-4 py-2.5 text-sm font-medium hover:border-[var(--l3-violet)] hover:bg-[var(--l3-violet-soft)] hover:text-[var(--l3-violet)] transition-colors"
          >
            Back to Home
          </Link>
        )
      }
      secondaryAction={
        detail ? (
          <code className="font-mono text-[0.65rem] opacity-60">{detail}</code>
        ) : undefined
      }
    />
  )
}
